import React from "react";
import "./Switch.scss";
import nextIconBlack from "assets/icons/black_carat.png";
import Button from "@mui/material/Button";
import ButtonGroup from "@mui/material/ButtonGroup";
import { useTranslation } from "react-i18next";
import { devLog } from "utils/devLog";
//deprecated function in 2.0 which presented a little switch icon to the user to toggle various services on and off
export default function Switch(props) {
  const { t } = useTranslation();

  if (props.IO.name === t("description.ConfirmInformationHeaderQuestion1")) {
    return (
      <div
        className="switch-component"
        onClick={() => {
          //devLog("very nice");
          props.func();
        }}
        style={{ background: "white" }}
      >
        {props.IO.img && <img src={props.IO.img} alt={props.IO.imgAlt} />}
        <p>{props.IO.name}</p>
        <div className="arrow">
          {/* <img src={nextIconBlack} alt="arrow"/> */}

          <ButtonGroup variant="contained">
            <Button variant={props.IO.bool ? "outlined" : "contained"}>
              {t("description.ConfirmServicesFlatYes")}
            </Button>
            <Button variant={props.IO.bool ? "contained" : "outlined"}>{t("description.ConfirmServicesFlatNo")}</Button>
          </ButtonGroup>
        </div>
      </div>
    );
  } else {
    return (
      <div
        className="switch-component"
        onClick={() => {
          //devLog("very nice");
          props.func();
        }}
        style={{ background: "white" }}
      >
        {props.IO.img && <img src={props.IO.img} alt={props.IO.imgAlt} />}
        <p>{props.IO.name}</p>
        <div className="arrow">
          {/* <img src={nextIconBlack} alt="arrow"/> */}

          <ButtonGroup variant="contained">
            <Button variant={props.IO.bool ? "contained" : "outlined"}>
              {t("description.ConfirmServicesFlatYes")}
            </Button>
            <Button variant={props.IO.bool ? "outlined" : "contained"}>{t("description.ConfirmServicesFlatNo")}</Button>
          </ButtonGroup>
        </div>
      </div>
    );
  }
}
